import { Form } from 'bonfire-kindling';

import { OrganizationDropdown } from 'components';
import { compareFieldObjectArray } from '../../utils';

const isEqual = (a, b) =>
  compareFieldObjectArray(a, b, {
    sort: o => o.OrganizationUUID,
    comparator: (a, b) =>
      a.OrganizationUUID === b.OrganizationUUID && a.OrganizationName === b.OrganizationName,
  });

const SavedSearchSettingsUpsertOrganizations = () => (
  <Form.Field isEqual={isEqual} name="organizations">
    {({ input }) => <OrganizationDropdown value={input.value} onChange={input.onChange} />}
  </Form.Field>
);

export default SavedSearchSettingsUpsertOrganizations;
